export const getPersianWeekDates = (
  articles: any[],
  project: any[],
  news: any[]
): any[] => {
  const today = new Date();
  const dates: any[] = [];

  for (let i = 7; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);

    const formattedDate = date.toLocaleDateString("fa-IR");

    const articleCount = articles.filter((article: any) => {
      const articleDate = new Date(article.created_at).toLocaleDateString(
        "fa-IR"
      );
      return articleDate === formattedDate;
    }).length;

    const projectCount = project.filter((project: any) => {
      const projectDate = new Date(project.created_at).toLocaleDateString(
        "fa-IR"
      );
      return projectDate === formattedDate;
    }).length;

    const newsCount = news.filter((news: any) => {
      const newsDate = new Date(news.created_at).toLocaleDateString("fa-IR");
      return newsDate === formattedDate;
    }).length;

    dates.push({
      name: formattedDate,
      articles: articleCount,
      projects: projectCount,
      news: newsCount,
    });
  }

  return dates;
};
